import { SUPPORTED_LANGUAGES } from "../../../app.constants";

export interface LocaleOption {
  code: string;
  label: string;
  displayCode: string;
}

function getDisplayCode(code: string): string {
  const parts = code.split("-");
  return parts.length > 1 ? parts[1].toUpperCase() : parts[0].toUpperCase();
}

export const locales: LocaleOption[] = SUPPORTED_LANGUAGES.map((lang) => ({
  code: lang.code,
  label: lang.label,
  displayCode: getDisplayCode(lang.code)
}));
